export const PAGES = {
  MAIN_PAGE: 'vendorsPage',
  VALUE_PAGE: 'modelsPage',
  ASR_MAIN_PAGE: 'asrvendorsPage',
  ASR_VALUE_PAGE: 'asrmodelsPage',
  TTS_MAIN_PAGE: 'ttsvendorsPage',
  TTS_VALUE_PAGE: 'ttsmodelsPage'
};
